import { render, staticRenderFns } from "./treasureSign.vue?vue&type=template&id=9a3fdf96&scoped=true&"
import script from "./treasureSign.vue?vue&type=script&lang=js&"
export * from "./treasureSign.vue?vue&type=script&lang=js&"
import style0 from "./treasureSign.vue?vue&type=style&index=0&id=9a3fdf96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3fdf96",
  null
  
)

export default component.exports